import { z } from "zod";

/** Schema for get-brands pagination input. */
const GetBrandsSchema = z.object({
  page_number: z.number().int().min(1),
  page_size: z.number().int().min(1).max(100),
});

export type GetBrandsDTOShape = z.infer<typeof GetBrandsSchema>;

/**
 * GetBrandsDTO – core contract for "get brands" input.
 * Use constructor when data is already valid; use validate() for untrusted input.
 */
export class GetBrandsDTO {
  readonly page_number!: number;
  readonly page_size!: number;

  constructor(data: GetBrandsDTOShape) {
    const validated = GetBrandsSchema.parse(data);
    Object.assign(this, validated);
  }

  static validate(data: unknown) {
    return GetBrandsSchema.safeParse(data);
  }
}
